import { Directive, OnDestroy, HostListener, ElementRef } from '@angular/core';
import * as jQuery from 'jquery';
@Directive({
  selector: '[title]'
})
export class TooltipDirective implements OnDestroy {

  private id: string;

  constructor(private element: ElementRef) {
    jQuery(".simple-tooltip").hide();
  }


  @HostListener('mouseenter', ['$event'])
  onMouseEnter(event: MouseEvent): void {
    let elm = jQuery(this.element.nativeElement);
    let title_tmp = elm.attr("title");
    if(title_tmp != ""){
      elm.attr("title", "");
      elm.attr("tooltip", title_tmp);

    }
    if(title_tmp!="" ||  elm.attr("tooltip")!= ""){
      jQuery(".simple-tooltip").show();
    }else{
      jQuery(".simple-tooltip").hide();
    }
    let X = event.clientX;
    let Y = event.clientY + elm.height() + 5;
    let tooltipText = elm.attr("tooltip");
    jQuery(".simple-tooltip").html(tooltipText);
    jQuery(".simple-tooltip").css({
      'top': Y,
      'left': X
    });
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    let elm = jQuery(this.element.nativeElement);
    let X = event.pageX;
    let Y = event.pageY + elm.height() + 5;
    jQuery(".simple-tooltip").css({
      'top': Y,
      'left': X
    });
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    jQuery(".simple-tooltip").hide();
  }

  ngOnDestroy(): void {
    jQuery(".simple-tooltip").hide();
  }


}



// WEBPACK FOOTER //
// ./src/app/modules/owners/components/TooltipDirective.ts